import { MetadataDatabankTemaPageGetRequest} from "@jobindsats/typescript-fetch-jobindsats";
import jobindsatsApi from "../../core/services/api-config";

export class UpdateCalendarService {
    getMetadataMaalingValues(requestParameters: MetadataDatabankTemaPageGetRequest) {
        return jobindsatsApi.getApi().metadataDatabankTemaPageGet(requestParameters);
    }

}